import type { ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Alert } from '@/components/ui/alert';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description: ReactNode;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
  destructive?: boolean;
  busy?: boolean;
  error?: string | null;
}

export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel,
  onConfirm,
  onCancel,
  destructive = true,
  busy = false,
  error,
}: ConfirmDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onCancel(); }}>
      <DialogContent style={{ maxWidth: 420 }}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="px-5 py-4 overflow-y-auto flex flex-col gap-3">
          {error && <Alert>{error}</Alert>}
          <p className="text-[14px] text-muted-foreground leading-relaxed">{description}</p>
        </div>
        <div className="flex justify-end gap-2 px-5 pb-5 pt-1">
          <Button variant="ghost" size="lg" className="min-h-[44px]" onClick={onCancel}>Annuler</Button>
          <Button
            size="lg"
            variant={destructive ? 'destructive' : 'default'}
            className="min-h-[44px]"
            disabled={busy}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
